import type { ReactNode } from 'react';
import { cx } from '../lib/cx';

export function Card({
  children,
  className,
  padding = 'md',
}: {
  children: ReactNode;
  className?: string;
  padding?: 'sm' | 'md' | 'lg' | 'none';
}) {
  const pad = { sm: 'p-2.5', md: 'p-3', lg: 'p-4', none: '' }[padding];
  return <section className={cx('v2-card', pad, className)}>{children}</section>;
}
